import React from 'react'

const Arrow = props => (
  <svg width="6px" height="8px" viewBox="0 0 6 8" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Path 13</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Nawigacja-NEW_1" transform="translate(-331.000000, -369.000000)" stroke="#777777">
              <polyline id="Path-13" transform="translate(333.951966, 372.903932) rotate(-90.000000) translate(-333.951966, -372.903932) " points="330.048034 370.951966 333.951966 374.855898 337.855898 370.951966"></polyline>
          </g>
      </g>
  </svg>
)

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/SVG/Arrow.js